/**
 * Defines valid values for the HTML autocomplete attribute.
 *
 * These values are documented here:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#values
 *
 * Some browsers intentionally ignore the "off" value because they believe that website
 * developers misuse it. For example, Chrome ignores the "off" value, and refuses to
 * change their behavior.
 *
 * @readonly
 * @enum {string}
 */
export const BROWSER_AUTOCOMPLETE_TOKEN = Object.freeze({
    // NOTE: This does not include all potential values. Add new ones according to the above
    // documentation as needed

    off: "off",

    // User information related values:
    givenName: "given-name",
    familyName: "family-name",
    email: "email",
    tel: "tel",
    organization: "organization",

    // Digital contact type related values:
    mobile: "mobile",
    home: "home",
    work: "work",

    // Address related values:
    streetAddress: "street-address",
    addressLine1: "address-line1",
    addressLine2: "address-line2",
    addressLevel1: "address-level1", // eg. US State
    addressLevel2: "address-level2", // eg. US City
    addressLevel3: "address-level3",
    addressLevel4: "address-level4",
    postalCode: "postal-code",
    country: "country",

    // Credential related values:
    username: "username",
    currentPassword: "current-password",
    newPassword: "new-password",
    oneTimeCode: "one-time-code"
});

export function isValidAutocompleteToken(value) {
    return Object.values(BROWSER_AUTOCOMPLETE_TOKEN).includes(value);
}
